// components
import { Button, Typography } from '@mui/material';
import { Dialog } from 'components/shared/index';
import { OverlapDialogProps } from './OverlapDialog.types';

// hooks
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// styles
import { ContentContainer } from './OverlapDialog.styles';
import { ActionsContainer } from '../styles';

export const OverlapDialog = ({
  messages = [],
  open,
  onClose,
  onOpen
}: OverlapDialogProps) => {
  const MAX_LINES = 5;

  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  useEffect(() => {
    open && onOpen?.();
  }, [open]);

  return (
    <Dialog
      handleClose={onClose?.bind(null, undefined)}
      open={open}
      title={t('dialogs.overlap.title')}
    >
      <ContentContainer>
        {messages.length > 0 &&
          messages
            .filter((_, index) => index < MAX_LINES)
            .map((message) => (
              <Typography variant="body1">{message}</Typography>
            ))}
        {messages.length > MAX_LINES && (
          <Typography variant="body1">
            •{' '}
            {t('dialogs.overlap.more', { count: messages.length - MAX_LINES })}
          </Typography>
        )}
        <ActionsContainer>
          <Button
            variant="text"
            fullWidth
            onClick={onClose?.bind(null, { ok: false })}
          >
            {t('dialogs.overlap.cancel')}
          </Button>

          <Button fullWidth onClick={onClose?.bind(null, { ok: true })}>
            {t('dialogs.overlap.confirm')}
          </Button>
        </ActionsContainer>
      </ContentContainer>
    </Dialog>
  );
};
